import { useTheme } from 'styled-components';

import { Message, MessageOptions, StyledMargin } from '@dreryk/react-components';

import { patientTranslationKeys } from '../translations';

import { PatientAssociateModalSubheadingPortal } from './patientAssociate/PatientAssociateModalSubheadingPortal';

const PATIENT_UNCONFIRMED_INCONSISTENT_DATA = 'patientUnconfirmedInconsistentData';
const useOptions = (): MessageOptions<Record<typeof PATIENT_UNCONFIRMED_INCONSISTENT_DATA, any>> => {
   const theme = useTheme();
   return {
      [PATIENT_UNCONFIRMED_INCONSISTENT_DATA]: {
         color: theme.warning,
         backgroundColor: theme.warningLighter,
         labelColor: theme.backgroundDarker,
      },
   };
};

export const PatientUnconfirmedFormInconsistentDataStatus = (): JSX.Element => {
   return (
      <PatientAssociateModalSubheadingPortal>
         <StyledMargin bottom={18}>
            <Message
               testId={'PATIENT_UNCONFIRMED_INCONSISTENT_DATA'}
               type={PATIENT_UNCONFIRMED_INCONSISTENT_DATA}
               options={useOptions()}
               label={patientTranslationKeys.unconfirmed.dataIsInconsistent}
               displayIndicator
               fullWidth
            />
         </StyledMargin>
      </PatientAssociateModalSubheadingPortal>
   );
};
